/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { aggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost } from '../fn/submissions-v-2/aggregate-submissions-api-v-2-submissions-org-submissions-data-overview-post';
import { AggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost$Params } from '../fn/submissions-v-2/aggregate-submissions-api-v-2-submissions-org-submissions-data-overview-post';
import { createSubmissionApiV2SubmissionsOrgPost } from '../fn/submissions-v-2/create-submission-api-v-2-submissions-org-post';
import { CreateSubmissionApiV2SubmissionsOrgPost$Params } from '../fn/submissions-v-2/create-submission-api-v-2-submissions-org-post';
import { createSubmissionDataApiV2SubmissionsOrgIdDataPost } from '../fn/submissions-v-2/create-submission-data-api-v-2-submissions-org-id-data-post';
import { CreateSubmissionDataApiV2SubmissionsOrgIdDataPost$Params } from '../fn/submissions-v-2/create-submission-data-api-v-2-submissions-org-id-data-post';
import { deleteSubmissionApiV2SubmissionsOrgIdDelete } from '../fn/submissions-v-2/delete-submission-api-v-2-submissions-org-id-delete';
import { DeleteSubmissionApiV2SubmissionsOrgIdDelete$Params } from '../fn/submissions-v-2/delete-submission-api-v-2-submissions-org-id-delete';
import { deleteUploadedFilesApiV2SubmissionsOrgIdFilesDelete } from '../fn/submissions-v-2/delete-uploaded-files-api-v-2-submissions-org-id-files-delete';
import { DeleteUploadedFilesApiV2SubmissionsOrgIdFilesDelete$Params } from '../fn/submissions-v-2/delete-uploaded-files-api-v-2-submissions-org-id-files-delete';
import { downloadDocxApiV2SubmissionsDownloadDocxPost } from '../fn/submissions-v-2/download-docx-api-v-2-submissions-download-docx-post';
import { DownloadDocxApiV2SubmissionsDownloadDocxPost$Params } from '../fn/submissions-v-2/download-docx-api-v-2-submissions-download-docx-post';
import { downloadPdfApiV2SubmissionsOrgDownloadPdfPost } from '../fn/submissions-v-2/download-pdf-api-v-2-submissions-org-download-pdf-post';
import { DownloadPdfApiV2SubmissionsOrgDownloadPdfPost$Params } from '../fn/submissions-v-2/download-pdf-api-v-2-submissions-org-download-pdf-post';
import { FileSignedUrl } from '../models/file-signed-url';
import { FilesUploaded } from '../models/files-uploaded';
import { getAllSubmissionsApiV2SubmissionsOrgAllGet } from '../fn/submissions-v-2/get-all-submissions-api-v-2-submissions-org-all-get';
import { GetAllSubmissionsApiV2SubmissionsOrgAllGet$Params } from '../fn/submissions-v-2/get-all-submissions-api-v-2-submissions-org-all-get';
import { getMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet } from '../fn/submissions-v-2/get-multiple-submissions-data-by-submissions-cycle-id-api-v-2-submissions-org-submissions-cycle-id-submissions-data-get';
import { GetMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet$Params } from '../fn/submissions-v-2/get-multiple-submissions-data-by-submissions-cycle-id-api-v-2-submissions-org-submissions-cycle-id-submissions-data-get';
import { getStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet } from '../fn/submissions-v-2/get-statistics-for-submissions-cycles-api-v-2-submissions-org-submissions-cycles-statistics-get';
import { GetStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet$Params } from '../fn/submissions-v-2/get-statistics-for-submissions-cycles-api-v-2-submissions-org-submissions-cycles-statistics-get';
import { getSubmissionApiV2SubmissionsOrgIdGet } from '../fn/submissions-v-2/get-submission-api-v-2-submissions-org-id-get';
import { GetSubmissionApiV2SubmissionsOrgIdGet$Params } from '../fn/submissions-v-2/get-submission-api-v-2-submissions-org-id-get';
import { getSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet } from '../fn/submissions-v-2/get-submission-files-uploaded-urls-api-v-2-submissions-org-id-files-url-get';
import { GetSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet$Params } from '../fn/submissions-v-2/get-submission-files-uploaded-urls-api-v-2-submissions-org-id-files-url-get';
import { getSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGet } from '../fn/submissions-v-2/get-submissions-by-recipient-api-v-2-submissions-org-submissions-get';
import { GetSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGet$Params } from '../fn/submissions-v-2/get-submissions-by-recipient-api-v-2-submissions-org-submissions-get';
import { getSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet } from '../fn/submissions-v-2/get-submissions-owned-by-secretariat-api-v-2-submissions-org-secretariat-submissions-get';
import { GetSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet$Params } from '../fn/submissions-v-2/get-submissions-owned-by-secretariat-api-v-2-submissions-org-secretariat-submissions-get';
import { getSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet } from '../fn/submissions-v-2/get-submissions-summary-by-submissions-cycle-api-v-2-submissions-org-submissions-cycle-id-submissions-summary-get';
import { GetSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Params } from '../fn/submissions-v-2/get-submissions-summary-by-submissions-cycle-api-v-2-submissions-org-submissions-cycle-id-submissions-summary-get';
import { PageSubmissions } from '../models/page-submissions';
import { PageSubmissionsSummary } from '../models/page-submissions-summary';
import { saveUploadedFilesApiV2SubmissionsOrgIdFilesPost } from '../fn/submissions-v-2/save-uploaded-files-api-v-2-submissions-org-id-files-post';
import { SaveUploadedFilesApiV2SubmissionsOrgIdFilesPost$Params } from '../fn/submissions-v-2/save-uploaded-files-api-v-2-submissions-org-id-files-post';
import { SubmissionDataAggregatedSubmissions } from '../models/submission-data-aggregated-submissions';
import { Submissions } from '../models/submissions';
import { SubmissionsData } from '../models/submissions-data';
import { SubmissionsDataMultipleWithSubmissionCycleData } from '../models/submissions-data-multiple-with-submission-cycle-data';
import { SubmissionsStatistics } from '../models/submissions-statistics';
import { SubmissionsWithOrgData } from '../models/submissions-with-org-data';
import { SubmissionsWithSubmissionsData } from '../models/submissions-with-submissions-data';
import { updateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch } from '../fn/submissions-v-2/update-submission-status-api-v-2-submissions-org-id-status-patch';
import { UpdateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch$Params } from '../fn/submissions-v-2/update-submission-status-api-v-2-submissions-org-id-status-patch';
import { uploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost } from '../fn/submissions-v-2/upload-submission-files-api-v-2-submissions-org-id-files-upload-post';
import { UploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost$Params } from '../fn/submissions-v-2/upload-submission-files-api-v-2-submissions-org-id-files-upload-post';

@Injectable({ providedIn: 'root' })
export class SubmissionsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllSubmissionsApiV2SubmissionsOrgAllGet()` */
  static readonly GetAllSubmissionsApiV2SubmissionsOrgAllGetPath = '/api/v2/submissions/{org}/all';

  /**
   * Get All Submissions.
   *
   * Retrieve all submissions.
   *
   * This endpoint fetches all submission documents from the database with any linked documents
   * included and returns the results in a paginated format.
   *
   * Args:
   *     org (Any): Organization details resolved from dependency injection.
   *
   * Returns:
   *     Page[schemas.Submissions]: A paginated list of submission documents.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSubmissionsApiV2SubmissionsOrgAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubmissionsApiV2SubmissionsOrgAllGet$Response(params: GetAllSubmissionsApiV2SubmissionsOrgAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSubmissions>> {
    return getAllSubmissionsApiV2SubmissionsOrgAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Submissions.
   *
   * Retrieve all submissions.
   *
   * This endpoint fetches all submission documents from the database with any linked documents
   * included and returns the results in a paginated format.
   *
   * Args:
   *     org (Any): Organization details resolved from dependency injection.
   *
   * Returns:
   *     Page[schemas.Submissions]: A paginated list of submission documents.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSubmissionsApiV2SubmissionsOrgAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubmissionsApiV2SubmissionsOrgAllGet(params: GetAllSubmissionsApiV2SubmissionsOrgAllGet$Params, context?: HttpContext): Observable<PageSubmissions> {
    return this.getAllSubmissionsApiV2SubmissionsOrgAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageSubmissions>): PageSubmissions => r.body)
    );
  }

  /** Path part for operation `getSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet()` */
  static readonly GetSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGetPath = '/api/v2/submissions/{org}/secretariat/submissions';

  /**
   * Get Submissions Owned By Secretariat.
   *
   * Retrieve submissions owned by the secretariat for a given organization.
   *
   * This endpoint retrieves submissions where the owner organization (secretariat) matches the tenant,
   * and the recipient organization matches the provided organization details. Additional data such as
   * recipient organization name, submission cycle end date, form name, and owner organization name are included.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     tenant (Any): The tenant identifier extracted from the authenticated JWT.
   *
   * Returns:
   *     list[schemas.SubmissionsWithOrgData]: A list of submissions with enriched organization data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet$Response(params: GetSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsWithOrgData>>> {
    return getSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Submissions Owned By Secretariat.
   *
   * Retrieve submissions owned by the secretariat for a given organization.
   *
   * This endpoint retrieves submissions where the owner organization (secretariat) matches the tenant,
   * and the recipient organization matches the provided organization details. Additional data such as
   * recipient organization name, submission cycle end date, form name, and owner organization name are included.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     tenant (Any): The tenant identifier extracted from the authenticated JWT.
   *
   * Returns:
   *     list[schemas.SubmissionsWithOrgData]: A list of submissions with enriched organization data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet(params: GetSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet$Params, context?: HttpContext): Observable<Array<SubmissionsWithOrgData>> {
    return this.getSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsWithOrgData>>): Array<SubmissionsWithOrgData> => r.body)
    );
  }

  /** Path part for operation `getSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGet()` */
  static readonly GetSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGetPath = '/api/v2/submissions/{org}/submissions';

  /**
   * Get Submissions By Recipient.
   *
   * Retrieve submissions where the given organization is the recipient.
   *
   * This endpoint fetches submissions filtered by the recipient organization ID (from org details),
   * excluding submissions where the owner organization matches the tenant or where the submission is deleted.
   * It then enriches the data with additional organization and form details.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     tenant (Any): The tenant identifier extracted from the authenticated JWT.
   *
   * Returns:
   *     list[schemas.SubmissionsWithOrgData]: A list of submissions with additional organization data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGet$Response(params: GetSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsWithOrgData>>> {
    return getSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Submissions By Recipient.
   *
   * Retrieve submissions where the given organization is the recipient.
   *
   * This endpoint fetches submissions filtered by the recipient organization ID (from org details),
   * excluding submissions where the owner organization matches the tenant or where the submission is deleted.
   * It then enriches the data with additional organization and form details.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     tenant (Any): The tenant identifier extracted from the authenticated JWT.
   *
   * Returns:
   *     list[schemas.SubmissionsWithOrgData]: A list of submissions with additional organization data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGet(params: GetSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGet$Params, context?: HttpContext): Observable<Array<SubmissionsWithOrgData>> {
    return this.getSubmissionsByRecipientApiV2SubmissionsOrgSubmissionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsWithOrgData>>): Array<SubmissionsWithOrgData> => r.body)
    );
  }

  /** Path part for operation `getStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet()` */
  static readonly GetStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGetPath = '/api/v2/submissions/{org}/submissions-cycles/statistics';

  /**
   * Get Statistics For Submissions Cycles.
   *
   * Retrieve submission statistics for each submission cycle of an organization.
   *
   * The endpoint aggregates submission counts (submitted, in progress, not started, and total)
   * for each submission cycle where the recipient organization differs from the tenant.
   *
   * Args:
   *     tenant (Any): The tenant identifier extracted from the authenticated JWT.
   *     org (Any): Organization details from dependency injection.
   *
   * Returns:
   *     list[schemas.SubmissionsStatistics]: A list of statistics data for each submission cycle.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet$Response(params: GetStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsStatistics>>> {
    return getStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Statistics For Submissions Cycles.
   *
   * Retrieve submission statistics for each submission cycle of an organization.
   *
   * The endpoint aggregates submission counts (submitted, in progress, not started, and total)
   * for each submission cycle where the recipient organization differs from the tenant.
   *
   * Args:
   *     tenant (Any): The tenant identifier extracted from the authenticated JWT.
   *     org (Any): Organization details from dependency injection.
   *
   * Returns:
   *     list[schemas.SubmissionsStatistics]: A list of statistics data for each submission cycle.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet(params: GetStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet$Params, context?: HttpContext): Observable<Array<SubmissionsStatistics>> {
    return this.getStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsStatistics>>): Array<SubmissionsStatistics> => r.body)
    );
  }

  /** Path part for operation `getSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet()` */
  static readonly GetSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGetPath = '/api/v2/submissions/{org}/submissions-cycle/{id}/submissions/summary';

  /**
   * Get Submissions Summary By Submissions Cycle.
   *
   * Retrieve a summary of submissions for a specific submissions cycle with optional filtering.
   *
   * The endpoint allows filtering by supplier name and submission statuses as well as sorting by status.
   * It returns a paginated summary of submission details including supplier company name, email, attachments, and status.
   *
   * Args:
   *     tenant (Any): The tenant identifier from the authenticated JWT.
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The submissions cycle identifier.
   *     supplierName (str | None, optional): Supplier name to filter submissions. Defaults to None.
   *     status (list[SubmissionsStatusFilterEnum] | None, optional): List of submission statuses to filter by. Defaults to None.
   *     sortStatus (Literal["asc", "desc"] | None, optional): Sorting order for the submission status. Defaults to None.
   *
   * Returns:
   *     Page[schemas.SubmissionsSummary]: A paginated summary of submissions for the given cycle.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Response(params: GetSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSubmissionsSummary>> {
    return getSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Submissions Summary By Submissions Cycle.
   *
   * Retrieve a summary of submissions for a specific submissions cycle with optional filtering.
   *
   * The endpoint allows filtering by supplier name and submission statuses as well as sorting by status.
   * It returns a paginated summary of submission details including supplier company name, email, attachments, and status.
   *
   * Args:
   *     tenant (Any): The tenant identifier from the authenticated JWT.
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The submissions cycle identifier.
   *     supplierName (str | None, optional): Supplier name to filter submissions. Defaults to None.
   *     status (list[SubmissionsStatusFilterEnum] | None, optional): List of submission statuses to filter by. Defaults to None.
   *     sortStatus (Literal["asc", "desc"] | None, optional): Sorting order for the submission status. Defaults to None.
   *
   * Returns:
   *     Page[schemas.SubmissionsSummary]: A paginated summary of submissions for the given cycle.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet(params: GetSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Params, context?: HttpContext): Observable<PageSubmissionsSummary> {
    return this.getSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageSubmissionsSummary>): PageSubmissionsSummary => r.body)
    );
  }

  /** Path part for operation `getSubmissionApiV2SubmissionsOrgIdGet()` */
  static readonly GetSubmissionApiV2SubmissionsOrgIdGetPath = '/api/v2/submissions/{org}/{id}';

  /**
   * Get Submission.
   *
   * Retrieve a submission by its identifier.
   *
   * This endpoint returns a submission document along with its associated submission data,
   * submission cycle details, and form data. It also validates that the submission is related
   * to the requesting organization.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *
   * Returns:
   *     schemas.SubmissionsWithSubmissionsData: The full submission details including submission data and cycle information.
   *
   * Raises:
   *     HTTPException: If the submission is not found or not authorized for the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubmissionApiV2SubmissionsOrgIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionApiV2SubmissionsOrgIdGet$Response(params: GetSubmissionApiV2SubmissionsOrgIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsWithSubmissionsData>> {
    return getSubmissionApiV2SubmissionsOrgIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Submission.
   *
   * Retrieve a submission by its identifier.
   *
   * This endpoint returns a submission document along with its associated submission data,
   * submission cycle details, and form data. It also validates that the submission is related
   * to the requesting organization.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *
   * Returns:
   *     schemas.SubmissionsWithSubmissionsData: The full submission details including submission data and cycle information.
   *
   * Raises:
   *     HTTPException: If the submission is not found or not authorized for the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubmissionApiV2SubmissionsOrgIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionApiV2SubmissionsOrgIdGet(params: GetSubmissionApiV2SubmissionsOrgIdGet$Params, context?: HttpContext): Observable<SubmissionsWithSubmissionsData> {
    return this.getSubmissionApiV2SubmissionsOrgIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionsWithSubmissionsData>): SubmissionsWithSubmissionsData => r.body)
    );
  }

  /** Path part for operation `deleteSubmissionApiV2SubmissionsOrgIdDelete()` */
  static readonly DeleteSubmissionApiV2SubmissionsOrgIdDeletePath = '/api/v2/submissions/{org}/{id}';

  /**
   * Delete Submission.
   *
   * Delete a submission by marking its status as deleted.
   *
   * This endpoint verifies that the submission is associated with the requesting organization
   * and updates its status to "deleted" along with the modified timestamp.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submission to be deleted.
   *
   * Returns:
   *     schemas.Submissions: The updated submission document.
   *
   * Raises:
   *     HTTPException: If the submission is not found or not associated with the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSubmissionApiV2SubmissionsOrgIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubmissionApiV2SubmissionsOrgIdDelete$Response(params: DeleteSubmissionApiV2SubmissionsOrgIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Submissions>> {
    return deleteSubmissionApiV2SubmissionsOrgIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Submission.
   *
   * Delete a submission by marking its status as deleted.
   *
   * This endpoint verifies that the submission is associated with the requesting organization
   * and updates its status to "deleted" along with the modified timestamp.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submission to be deleted.
   *
   * Returns:
   *     schemas.Submissions: The updated submission document.
   *
   * Raises:
   *     HTTPException: If the submission is not found or not associated with the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSubmissionApiV2SubmissionsOrgIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubmissionApiV2SubmissionsOrgIdDelete(params: DeleteSubmissionApiV2SubmissionsOrgIdDelete$Params, context?: HttpContext): Observable<Submissions> {
    return this.deleteSubmissionApiV2SubmissionsOrgIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Submissions>): Submissions => r.body)
    );
  }

  /** Path part for operation `createSubmissionApiV2SubmissionsOrgPost()` */
  static readonly CreateSubmissionApiV2SubmissionsOrgPostPath = '/api/v2/submissions/{org}';

  /**
   * Create Submission.
   *
   * Create a new submission document.
   *
   * This endpoint creates a submission record after verifying the submissions cycle,
   * checking permissions, and ensuring that a duplicate submission does not already exist.
   * It also determines the owner organization based on the mode parameter.
   *
   * It sends out an email to downstream user (recipient_org) once a submission record is created.
   *
   * Args:
   *     auth_token (Any): The authentication token containing user details.
   *     tenant (Any): The tenant identifier extracted from the JWT.
   *     org (Any): Organization details from dependency injection.
   *     submission_in (schemas.SubmissionsCreate): The submission data to be created.
   *     background_tasks (BackgroundTasks): Background task manager for asynchronous processing.
   *     self_start (bool | None, optional): Flag to determine if the submission should self-start. Defaults to None.
   *     mode (Literal["upstream", "secretariat"] | None, optional):
   *         Determines the owner organization assignment:
   *         - "secretariat": owner_org_id = tenant
   *         - "upstream": owner_org_id = org.org_id
   *         - None (default): uses submissions_cycle.owner_org_id if not empty, otherwise org.org_id
   *
   * Returns:
   *     schemas.Submissions: The newly created submission document.
   *
   * Raises:
   *     HTTPException: For invalid submissions cycle, duplicate submissions, invalid organization IDs,
   *                    or insufficient permissions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubmissionApiV2SubmissionsOrgPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubmissionApiV2SubmissionsOrgPost$Response(params: CreateSubmissionApiV2SubmissionsOrgPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Submissions>> {
    return createSubmissionApiV2SubmissionsOrgPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Submission.
   *
   * Create a new submission document.
   *
   * This endpoint creates a submission record after verifying the submissions cycle,
   * checking permissions, and ensuring that a duplicate submission does not already exist.
   * It also determines the owner organization based on the mode parameter.
   *
   * It sends out an email to downstream user (recipient_org) once a submission record is created.
   *
   * Args:
   *     auth_token (Any): The authentication token containing user details.
   *     tenant (Any): The tenant identifier extracted from the JWT.
   *     org (Any): Organization details from dependency injection.
   *     submission_in (schemas.SubmissionsCreate): The submission data to be created.
   *     background_tasks (BackgroundTasks): Background task manager for asynchronous processing.
   *     self_start (bool | None, optional): Flag to determine if the submission should self-start. Defaults to None.
   *     mode (Literal["upstream", "secretariat"] | None, optional):
   *         Determines the owner organization assignment:
   *         - "secretariat": owner_org_id = tenant
   *         - "upstream": owner_org_id = org.org_id
   *         - None (default): uses submissions_cycle.owner_org_id if not empty, otherwise org.org_id
   *
   * Returns:
   *     schemas.Submissions: The newly created submission document.
   *
   * Raises:
   *     HTTPException: For invalid submissions cycle, duplicate submissions, invalid organization IDs,
   *                    or insufficient permissions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSubmissionApiV2SubmissionsOrgPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubmissionApiV2SubmissionsOrgPost(params: CreateSubmissionApiV2SubmissionsOrgPost$Params, context?: HttpContext): Observable<Submissions> {
    return this.createSubmissionApiV2SubmissionsOrgPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Submissions>): Submissions => r.body)
    );
  }

  /** Path part for operation `createSubmissionDataApiV2SubmissionsOrgIdDataPost()` */
  static readonly CreateSubmissionDataApiV2SubmissionsOrgIdDataPostPath = '/api/v2/submissions/{org}/{id}/data';

  /**
   * Create Submission Data.
   *
   * Create or update a submissions data document for a given submission.
   *
   * This endpoint attaches submissions data to an existing submission, stores the data in the file store,
   * updates the submission's modified timestamp, and optionally triggers a background task to
   * calculate the submission percentage.
   *
   * Args:
   *     request (Request): The HTTP request object.
   *     tenant (Any): The tenant identifier from the authenticated JWT.
   *     org (Any): Organization details from dependency injection.
   *     submissions_data_in (schemas.SubmissionsDataCreate): The submissions data payload.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *     background_tasks (BackgroundTasks): Background task manager for asynchronous processing.
   *
   * Returns:
   *     schemas.SubmissionsData: The created or updated submissions data document.
   *
   * Raises:
   *     HTTPException: For invalid submission ID, unauthorized access, empty data payload,
   *                    or if the submission has been deleted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubmissionDataApiV2SubmissionsOrgIdDataPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubmissionDataApiV2SubmissionsOrgIdDataPost$Response(params: CreateSubmissionDataApiV2SubmissionsOrgIdDataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsData>> {
    return createSubmissionDataApiV2SubmissionsOrgIdDataPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Submission Data.
   *
   * Create or update a submissions data document for a given submission.
   *
   * This endpoint attaches submissions data to an existing submission, stores the data in the file store,
   * updates the submission's modified timestamp, and optionally triggers a background task to
   * calculate the submission percentage.
   *
   * Args:
   *     request (Request): The HTTP request object.
   *     tenant (Any): The tenant identifier from the authenticated JWT.
   *     org (Any): Organization details from dependency injection.
   *     submissions_data_in (schemas.SubmissionsDataCreate): The submissions data payload.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *     background_tasks (BackgroundTasks): Background task manager for asynchronous processing.
   *
   * Returns:
   *     schemas.SubmissionsData: The created or updated submissions data document.
   *
   * Raises:
   *     HTTPException: For invalid submission ID, unauthorized access, empty data payload,
   *                    or if the submission has been deleted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSubmissionDataApiV2SubmissionsOrgIdDataPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubmissionDataApiV2SubmissionsOrgIdDataPost(params: CreateSubmissionDataApiV2SubmissionsOrgIdDataPost$Params, context?: HttpContext): Observable<SubmissionsData> {
    return this.createSubmissionDataApiV2SubmissionsOrgIdDataPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionsData>): SubmissionsData => r.body)
    );
  }

  /** Path part for operation `saveUploadedFilesApiV2SubmissionsOrgIdFilesPost()` */
  static readonly SaveUploadedFilesApiV2SubmissionsOrgIdFilesPostPath = '/api/v2/submissions/{org}/{id}/files';

  /**
   * Save Uploaded Files.
   *
   * Update the list of uploaded files for a submission.
   *
   * This endpoint adds new file entries to the submission's files_uploaded array if they are not already present.
   * It verifies that the submission exists and that the requesting organization is authorized to modify it.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     files_uploaded_in (schemas.FilesUploadedUpdate): The files data to be added.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *
   * Returns:
   *     list[schemas.FilesUploaded]: The updated list of uploaded files.
   *
   * Raises:
   *     HTTPException: If the submission is not found, unauthorized, or the file already exists.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveUploadedFilesApiV2SubmissionsOrgIdFilesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveUploadedFilesApiV2SubmissionsOrgIdFilesPost$Response(params: SaveUploadedFilesApiV2SubmissionsOrgIdFilesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FilesUploaded>>> {
    return saveUploadedFilesApiV2SubmissionsOrgIdFilesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Save Uploaded Files.
   *
   * Update the list of uploaded files for a submission.
   *
   * This endpoint adds new file entries to the submission's files_uploaded array if they are not already present.
   * It verifies that the submission exists and that the requesting organization is authorized to modify it.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     files_uploaded_in (schemas.FilesUploadedUpdate): The files data to be added.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *
   * Returns:
   *     list[schemas.FilesUploaded]: The updated list of uploaded files.
   *
   * Raises:
   *     HTTPException: If the submission is not found, unauthorized, or the file already exists.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `saveUploadedFilesApiV2SubmissionsOrgIdFilesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveUploadedFilesApiV2SubmissionsOrgIdFilesPost(params: SaveUploadedFilesApiV2SubmissionsOrgIdFilesPost$Params, context?: HttpContext): Observable<Array<FilesUploaded>> {
    return this.saveUploadedFilesApiV2SubmissionsOrgIdFilesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FilesUploaded>>): Array<FilesUploaded> => r.body)
    );
  }

  /** Path part for operation `deleteUploadedFilesApiV2SubmissionsOrgIdFilesDelete()` */
  static readonly DeleteUploadedFilesApiV2SubmissionsOrgIdFilesDeletePath = '/api/v2/submissions/{org}/{id}/files';

  /**
   * Delete Uploaded Files.
   *
   * Delete one or more uploaded files from a submission.
   *
   * This endpoint removes file entries whose asset_url or upload_path matches any of the provided URLs from the submission's files_uploaded field.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     urls (list[str]): List of asset URLs or upload paths to be removed.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *
   * Returns:
   *     list[schemas.FilesUploaded]: The updated list of uploaded files.
   *
   * Raises:
   *     HTTPException: If the submission is not found, unauthorized, or if no matching URLs are found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUploadedFilesApiV2SubmissionsOrgIdFilesDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteUploadedFilesApiV2SubmissionsOrgIdFilesDelete$Response(params: DeleteUploadedFilesApiV2SubmissionsOrgIdFilesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FilesUploaded>>> {
    return deleteUploadedFilesApiV2SubmissionsOrgIdFilesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Uploaded Files.
   *
   * Delete one or more uploaded files from a submission.
   *
   * This endpoint removes file entries whose asset_url or upload_path matches any of the provided URLs from the submission's files_uploaded field.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     urls (list[str]): List of asset URLs or upload paths to be removed.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *
   * Returns:
   *     list[schemas.FilesUploaded]: The updated list of uploaded files.
   *
   * Raises:
   *     HTTPException: If the submission is not found, unauthorized, or if no matching URLs are found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUploadedFilesApiV2SubmissionsOrgIdFilesDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteUploadedFilesApiV2SubmissionsOrgIdFilesDelete(params: DeleteUploadedFilesApiV2SubmissionsOrgIdFilesDelete$Params, context?: HttpContext): Observable<Array<FilesUploaded>> {
    return this.deleteUploadedFilesApiV2SubmissionsOrgIdFilesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FilesUploaded>>): Array<FilesUploaded> => r.body)
    );
  }

  /** Path part for operation `uploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost()` */
  static readonly UploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPostPath = '/api/v2/submissions/{org}/{id}/files/upload';

  /**
   * Upload Submission Files.
   *
   * Upload media files for submissions (each not exceeding 25MB) to a file store.
   *
   * This endpoint:
   *   - Validates that the submission exists and that the requesting organization is authorized.
   *   - Accepts one or more file uploads.
   *   - Checks each file's size ensuring it does not exceed 25MB.
   *   - Rejects files with a .zip extension.
   *   - Saves the file in a file store using the original filename.
   *   - Updates the submission's file list with the URL to the uploaded file.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *     files (List[UploadFile]): One or more files to upload.
   *
   * Returns:
   *     List[schemas.FilesUploaded]: The updated list of uploaded files.
   *
   * Raises:
   *     HTTPException: If the submission is not found, unauthorized, any file exceeds the allowed size,
   *                    or a .zip file is provided.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost$Response(params: UploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FilesUploaded>>> {
    return uploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload Submission Files.
   *
   * Upload media files for submissions (each not exceeding 25MB) to a file store.
   *
   * This endpoint:
   *   - Validates that the submission exists and that the requesting organization is authorized.
   *   - Accepts one or more file uploads.
   *   - Checks each file's size ensuring it does not exceed 25MB.
   *   - Rejects files with a .zip extension.
   *   - Saves the file in a file store using the original filename.
   *   - Updates the submission's file list with the URL to the uploaded file.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *     files (List[UploadFile]): One or more files to upload.
   *
   * Returns:
   *     List[schemas.FilesUploaded]: The updated list of uploaded files.
   *
   * Raises:
   *     HTTPException: If the submission is not found, unauthorized, any file exceeds the allowed size,
   *                    or a .zip file is provided.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost(params: UploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost$Params, context?: HttpContext): Observable<Array<FilesUploaded>> {
    return this.uploadSubmissionFilesApiV2SubmissionsOrgIdFilesUploadPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FilesUploaded>>): Array<FilesUploaded> => r.body)
    );
  }

  /** Path part for operation `getSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet()` */
  static readonly GetSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGetPath = '/api/v2/submissions/{org}/{id}/files/url';

  /**
   * Get Submission Files Uploaded Urls.
   *
   * Retrieve signed URLs for submission files stored in the file store.
   *
   * This endpoint:
   *   - Validates that the submission exists and that the requesting organization is authorized.
   *   - If a list of file names is provided via the 'filename' query parameter, returns signed URLs for those specific files.
   *   - If no file names are provided, returns signed URLs for all uploaded files.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *     filenames (Optional[List[str]]): List of file names to filter the signed URLs.
   *     expiration_minutes (Optional[int]): Signed URL expiration in minutes (default: 15).
   *
   * Returns:
   *     list[schemas.FileSignedUrl]: A list of dictionaries containing file names and their signed URLs.
   *
   * Raises:
   *     HTTPException: If the submission is not found, the organization is unauthorized, or no files match the provided names.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet$Response(params: GetSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FileSignedUrl>>> {
    return getSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Submission Files Uploaded Urls.
   *
   * Retrieve signed URLs for submission files stored in the file store.
   *
   * This endpoint:
   *   - Validates that the submission exists and that the requesting organization is authorized.
   *   - If a list of file names is provided via the 'filename' query parameter, returns signed URLs for those specific files.
   *   - If no file names are provided, returns signed URLs for all uploaded files.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *     filenames (Optional[List[str]]): List of file names to filter the signed URLs.
   *     expiration_minutes (Optional[int]): Signed URL expiration in minutes (default: 15).
   *
   * Returns:
   *     list[schemas.FileSignedUrl]: A list of dictionaries containing file names and their signed URLs.
   *
   * Raises:
   *     HTTPException: If the submission is not found, the organization is unauthorized, or no files match the provided names.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet(params: GetSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet$Params, context?: HttpContext): Observable<Array<FileSignedUrl>> {
    return this.getSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FileSignedUrl>>): Array<FileSignedUrl> => r.body)
    );
  }

  /** Path part for operation `updateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch()` */
  static readonly UpdateSubmissionStatusApiV2SubmissionsOrgIdStatusPatchPath = '/api/v2/submissions/{org}/{id}/status';

  /**
   * Update Submission Status.
   *
   * Update the status of a submission.
   *
   * This endpoint updates a submission's status to either "pending" (start, reopen), "completed" (complete)
   * based on the provided action. It verifies that the submission is associated with the requesting organization.
   * If the action is "complete", it triggers an email confirmation as a background task.
   *
   * Args:
   *     auth_token (Any): The authentication token containing user details.
   *     tenant (Any): The tenant identifier extracted from the authenticated JWT.
   *     org (Any): Organization details from dependency injection.
   *     action (Literal["start", "complete"]): The action to update the submission's status.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *     background_tasks (BackgroundTasks): The background task manager for asynchronous tasks.
   *
   * Returns:
   *     schemas.Submissions: The updated submission document.
   *
   * Raises:
   *     HTTPException: If the submission is not found or if the update is not authorized.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch$Response(params: UpdateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<Submissions>> {
    return updateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Submission Status.
   *
   * Update the status of a submission.
   *
   * This endpoint updates a submission's status to either "pending" (start, reopen), "completed" (complete)
   * based on the provided action. It verifies that the submission is associated with the requesting organization.
   * If the action is "complete", it triggers an email confirmation as a background task.
   *
   * Args:
   *     auth_token (Any): The authentication token containing user details.
   *     tenant (Any): The tenant identifier extracted from the authenticated JWT.
   *     org (Any): Organization details from dependency injection.
   *     action (Literal["start", "complete"]): The action to update the submission's status.
   *     id (PydanticObjectId): The unique identifier of the submission.
   *     background_tasks (BackgroundTasks): The background task manager for asynchronous tasks.
   *
   * Returns:
   *     schemas.Submissions: The updated submission document.
   *
   * Raises:
   *     HTTPException: If the submission is not found or if the update is not authorized.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch(params: UpdateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch$Params, context?: HttpContext): Observable<Submissions> {
    return this.updateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<Submissions>): Submissions => r.body)
    );
  }

  /** Path part for operation `downloadPdfApiV2SubmissionsOrgDownloadPdfPost()` */
  static readonly DownloadPdfApiV2SubmissionsOrgDownloadPdfPostPath = '/api/v2/submissions/{org}/download/pdf';

  /**
   * Download Pdf.
   *
   * Download a PDF generated from the provided HTML content.
   *
   * This endpoint converts the given HTML string into a PDF document and returns it as a streaming response
   * with appropriate headers to prompt a file download.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     body (schemas.HtmlContent): An object containing the HTML string to be converted.
   *
   * Returns:
   *     StreamingResponse: A streaming response containing the generated PDF document.
   *
   * Raises:
   *     HTTPException: If an error occurs during PDF conversion.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadPdfApiV2SubmissionsOrgDownloadPdfPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  downloadPdfApiV2SubmissionsOrgDownloadPdfPost$Response(params: DownloadPdfApiV2SubmissionsOrgDownloadPdfPost$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return downloadPdfApiV2SubmissionsOrgDownloadPdfPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Download Pdf.
   *
   * Download a PDF generated from the provided HTML content.
   *
   * This endpoint converts the given HTML string into a PDF document and returns it as a streaming response
   * with appropriate headers to prompt a file download.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     body (schemas.HtmlContent): An object containing the HTML string to be converted.
   *
   * Returns:
   *     StreamingResponse: A streaming response containing the generated PDF document.
   *
   * Raises:
   *     HTTPException: If an error occurs during PDF conversion.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadPdfApiV2SubmissionsOrgDownloadPdfPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  downloadPdfApiV2SubmissionsOrgDownloadPdfPost(params: DownloadPdfApiV2SubmissionsOrgDownloadPdfPost$Params, context?: HttpContext): Observable<any> {
    return this.downloadPdfApiV2SubmissionsOrgDownloadPdfPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `getMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet()` */
  static readonly GetMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGetPath = '/api/v2/submissions/{org}/submissions-cycle/{id}/submissions/data';

  /**
   * Get Multiple Submissions Data By Submissions Cycle Id.
   *
   * Retrieve multiple submissions data for a specific submissions cycle.
   *
   * This endpoint fetches the submissions cycle details along with its associated form data,
   * and then retrieves submissions data for submissions whose IDs match the provided list.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The submissions cycle identifier.
   *     submission_ids (list[PydanticObjectId]): A list of submission IDs to filter the results.
   *
   * Returns:
   *     dict: A dictionary containing the submissions cycle data (including form data) and the corresponding submissions data.
   *
   * Raises:
   *     HTTPException: If the submissions cycle is not found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet$Response(params: GetMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsDataMultipleWithSubmissionCycleData>> {
    return getMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Multiple Submissions Data By Submissions Cycle Id.
   *
   * Retrieve multiple submissions data for a specific submissions cycle.
   *
   * This endpoint fetches the submissions cycle details along with its associated form data,
   * and then retrieves submissions data for submissions whose IDs match the provided list.
   *
   * Args:
   *     org (Any): Organization details from dependency injection.
   *     id (PydanticObjectId): The submissions cycle identifier.
   *     submission_ids (list[PydanticObjectId]): A list of submission IDs to filter the results.
   *
   * Returns:
   *     dict: A dictionary containing the submissions cycle data (including form data) and the corresponding submissions data.
   *
   * Raises:
   *     HTTPException: If the submissions cycle is not found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet(params: GetMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet$Params, context?: HttpContext): Observable<SubmissionsDataMultipleWithSubmissionCycleData> {
    return this.getMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionsDataMultipleWithSubmissionCycleData>): SubmissionsDataMultipleWithSubmissionCycleData => r.body)
    );
  }

  /** Path part for operation `aggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost()` */
  static readonly AggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPostPath = '/api/v2/submissions/{org}/submissions/data/overview';

  /**
   * Submissions Data Results Overview.
   *
   * Aggregate submission responses for specified question IDs and prepare data for results overview plotting.
   *
   * This endpoint aggregates submission data for a given organization and submission cycle.
   * It extracts the raw responses for each question ID specified in the input and computes aggregated counts,
   * transforming raw responses into a structured overview.
   *
   * The process includes:
   *   - Validating that the authenticated user is a member of the organization.
   *   - Retrieving submissions based on the owner's organization, submission cycle ID, and submission status.
   *   - Fetching detailed submission data using the submission IDs.
   *   - Combining submission data with their corresponding IDs.
   *   - Summarizing the responses by question IDs, including raw responses (as a dictionary mapped by submission_data_id)
   *     and aggregation of answer counts.
   *   - Adjusting response types (e.g., flagging responses as "bool" if they are "yes", "no", or "null").
   *
   * Parameters:
   *     auth_token (Any): The authentication token containing user details, validated via dependency injection.
   *     org (Any): Organization details obtained via dependency injection; must include a team list with member emails.
   *     input (SubmissionDataAggregationInput): Input schema specifying the submission cycle ID and a list of question IDs.
   *     showCompletedOnly (bool): Query parameter to filter submissions. When True, only submissions with status "completed" are considered.
   *
   * Returns:
   *     dict: A dictionary with a single key "results" containing a list of aggregated submission data,
   *           conforming to the SubmissionDataAggregatedSubmissions schema.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the specified organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost$Response(params: AggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionDataAggregatedSubmissions>> {
    return aggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Submissions Data Results Overview.
   *
   * Aggregate submission responses for specified question IDs and prepare data for results overview plotting.
   *
   * This endpoint aggregates submission data for a given organization and submission cycle.
   * It extracts the raw responses for each question ID specified in the input and computes aggregated counts,
   * transforming raw responses into a structured overview.
   *
   * The process includes:
   *   - Validating that the authenticated user is a member of the organization.
   *   - Retrieving submissions based on the owner's organization, submission cycle ID, and submission status.
   *   - Fetching detailed submission data using the submission IDs.
   *   - Combining submission data with their corresponding IDs.
   *   - Summarizing the responses by question IDs, including raw responses (as a dictionary mapped by submission_data_id)
   *     and aggregation of answer counts.
   *   - Adjusting response types (e.g., flagging responses as "bool" if they are "yes", "no", or "null").
   *
   * Parameters:
   *     auth_token (Any): The authentication token containing user details, validated via dependency injection.
   *     org (Any): Organization details obtained via dependency injection; must include a team list with member emails.
   *     input (SubmissionDataAggregationInput): Input schema specifying the submission cycle ID and a list of question IDs.
   *     showCompletedOnly (bool): Query parameter to filter submissions. When True, only submissions with status "completed" are considered.
   *
   * Returns:
   *     dict: A dictionary with a single key "results" containing a list of aggregated submission data,
   *           conforming to the SubmissionDataAggregatedSubmissions schema.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the specified organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost(params: AggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost$Params, context?: HttpContext): Observable<SubmissionDataAggregatedSubmissions> {
    return this.aggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionDataAggregatedSubmissions>): SubmissionDataAggregatedSubmissions => r.body)
    );
  }

  /** Path part for operation `downloadDocxApiV2SubmissionsDownloadDocxPost()` */
  static readonly DownloadDocxApiV2SubmissionsDownloadDocxPostPath = '/api/v2/submissions/download/docx';

  /**
   * Download Docx.
   *
   * Convert a PDF generated from HTML content to a DOCX file and return it as a streaming response.
   *
   * This endpoint first converts the provided HTML content to a PDF file using an existing conversion function.
   * It then writes the PDF to a temporary file and uses the pdf2docx library to convert the PDF into a DOCX file.
   * The resulting DOCX file is read into memory and returned as a StreamingResponse with the appropriate
   * media type and content disposition headers for file download.
   *
   * Raises:
   *     HTTPException: If the conversion process fails, returns a 503 status with a relevant error message.
   *
   * Returns:
   *     StreamingResponse: A streaming response containing the DOCX file ready for download.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadDocxApiV2SubmissionsDownloadDocxPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  downloadDocxApiV2SubmissionsDownloadDocxPost$Response(params: DownloadDocxApiV2SubmissionsDownloadDocxPost$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return downloadDocxApiV2SubmissionsDownloadDocxPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Download Docx.
   *
   * Convert a PDF generated from HTML content to a DOCX file and return it as a streaming response.
   *
   * This endpoint first converts the provided HTML content to a PDF file using an existing conversion function.
   * It then writes the PDF to a temporary file and uses the pdf2docx library to convert the PDF into a DOCX file.
   * The resulting DOCX file is read into memory and returned as a StreamingResponse with the appropriate
   * media type and content disposition headers for file download.
   *
   * Raises:
   *     HTTPException: If the conversion process fails, returns a 503 status with a relevant error message.
   *
   * Returns:
   *     StreamingResponse: A streaming response containing the DOCX file ready for download.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadDocxApiV2SubmissionsDownloadDocxPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  downloadDocxApiV2SubmissionsDownloadDocxPost(params: DownloadDocxApiV2SubmissionsDownloadDocxPost$Params, context?: HttpContext): Observable<any> {
    return this.downloadDocxApiV2SubmissionsDownloadDocxPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
